import script from "./SpatialVision.vue?vue&type=script&lang=ts&setup=true"
export * from "./SpatialVision.vue?vue&type=script&lang=ts&setup=true"

import "./SpatialVision.vue?vue&type=style&index=0&id=1ca4eb25&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca4eb25"]])

export default __exports__